module.exports = __webpack_public_path__ + "static/media/speak_pro.7330fa96.jpg";